import { useCallback, useEffect, useState } from "react";
import $ from "jquery";
export default function useIsMobile(breakPoint=800) {
  const [isMobile, setIsMobile] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  $(window).on("resize", function () {
    setWindowWidth(window.innerWidth);
  });
  const checkDevice = useCallback(() => {
    const userAgent = navigator.userAgent;

    if (
      userAgent.match(/Android/i) ||
      userAgent.match(/iPhone/i) ||
      windowWidth < breakPoint
    ) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);

  useEffect(() => {
    checkDevice();
  }, [checkDevice, windowWidth]);

  return {
    checkDevice,
    isMobile,
  };
}